module.exports = __webpack_public_path__ + "static/media/bet3000.a29f4996.png";